import produce from 'immer'

import ActionTypes from './ActionTypes'

/** @type {IDeliveryOrderState} */
const initialState = {
  isInit: false,
  data: [],
  meta: {
    perPage: 50,
    currentPage: 1,
  },
}

export default produce(
  /**
   * @param {IDeliveryOrderState} draft
   * @param {IAction} action
   */
  (draft, action) => {
    switch (action?.type) {
      case ActionTypes.INIT: {
        draft.isInit = true
        break
      }
      case ActionTypes.UPDATE_DATA: {
        const { data } = action.payload
        draft.data = data
        break
      }
      case ActionTypes.UPDATE_META: {
        const { meta } = action.payload
        draft.meta = { ...draft.meta, ...meta }
        break
      }
      default:
        break
    }
  },
  initialState,
)
